import branch from '@/api/branch'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  companies: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_COMPANIES(state, data) {
    state.companies = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return branch.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return branch.store(data)
  },
  update(context, data) {
    return branch.update(data)
  },
  uploadLogo(context, data) {
    return branch.uploadfile(data)
  },
  destroy(context, id) {
    return branch.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      console.log('edit data set')
      let response = await branch.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.companies.length > 0) {
      let response = await branch.branchCompany()
      context.commit('SET_COMPANIES', response)
    }
  }
}
